export const BASE_API_DEV = "http://localhost:4000";
// export const BASE_API_DEV = "https://isms.impuls.run/api";

export const BASE_API_PROD = "https://smaitnh.api.isms.impuls.id";
export const BASE_API_PROD_SMAITNH = "https://api-sis.smaitnh.sch.id";

export const SEKOLAH_KODE = "smaitnh";

export const APP_TIMEZONE = "Asia/Jakarta";
